import React from 'react';
import { Title, Body } from '@vds/typography';
import {Line} from '@vds/lines';
import styled from 'styled-components';

const StyledSubcontent = styled.div`
  padding-top:8px;
  `
  const StyledLine = styled.div`padding-top:16px`

export const ContactUsHelloBanner = ({HelloTitle,HelloDesc}) => {
      
    return (
        <div className="Helorow">
          <Title ariaLabel={HelloTitle} size="large" viewport="mobile">
            {HelloTitle}
          </Title>
          <StyledSubcontent>
            <Body primitive="p" ariaLabel={HelloDesc} size="small" bold viewport="mobile">
            {HelloDesc}
            </Body>
          </StyledSubcontent>
          <StyledLine>
            <Line />
          </StyledLine>                                   
      </div>        
    )
}


// WEBPACK FOOTER //
// ./src/components/modules/ContactUsHelloBanner.js